import { render, staticRenderFns } from "./DeleteApiKey.vue?vue&type=template&id=f24efd20&scoped=true&"
import script from "./DeleteApiKey.vue?vue&type=script&lang=ts&"
export * from "./DeleteApiKey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24efd20",
  null
  
)

export default component.exports